<script setup>
import { useI18n } from 'vue-i18n';
import { appointmentMessages } from '../templates/appointmentMessages';
const props = defineProps({
  node: { type: Object, required: true },
  trigger: { type: Object, required: true },
});
const emit = defineEmits(['update:node']);
const { t } = useI18n({ useScope: 'local', messages: appointmentMessages });
const update = values => emit('update:node', { ...props.node, ...values });
const changeField = (field, checked) =>
  update({
    change_fields: checked
      ? [...(props.node.change_fields || []), field]
      : (props.node.change_fields || []).filter(key => key !== field),
  });
</script>

<template>
  <section
    v-if="trigger.entity === 'appointments'"
    class="my-4 py-4 border-y border-n-weak space-y-3"
  >
    <label class="block text-xs"
      >{{ t('purpose') }}
      <select
        :value="node.purpose || 'notification'"
        class="w-full mt-1"
        @change="
          update({
            purpose: $event.target.value,
            appointment_mode: 'single',
            change_fields: [
              'planned_start_at',
              'doctor_mis_id',
              'to_branches_mis_id',
            ],
          })
        "
      >
        <option
          v-for="purpose in [
            'notification',
            'reminder',
            'change',
            'cancellation',
          ]"
          :key="purpose"
          :value="purpose"
          :disabled="
            purpose === 'change' &&
            (trigger.mode === 'schedule' || trigger.event !== 'updated')
          "
        >
          {{ t(purpose) }}
        </option>
      </select>
    </label>
    <template v-if="node.purpose === 'change'">
      <p class="text-xs text-n-slate-11">{{ t('changeHint') }}</p>
      <fieldset class="space-y-2">
        <legend class="text-xs mb-2">{{ t('changes') }}</legend>
        <label
          v-for="(label, field) in {
            planned_start_at: 'dateTime',
            doctor_mis_id: 'doctor',
            to_branches_mis_id: 'branch',
          }"
          :key="field"
          class="flex gap-2 items-center text-sm"
          ><input
            type="checkbox"
            :checked="(node.change_fields || []).includes(field)"
            @change="changeField(field, $event.target.checked)"
          />{{ t(label) }}</label
        >
      </fieldset>
    </template>
    <template v-if="node.purpose === 'reminder'">
      <label class="block text-xs"
        >{{ t('grouping')
        }}<select
          :value="node.appointment_mode || 'single'"
          class="w-full mt-1"
          @change="
            update({
              appointment_mode: $event.target.value,
              success_on: 'accepted',
            })
          "
        >
          <option value="single">{{ t('separately') }}</option>
          <option value="patient_day" :disabled="trigger.mode !== 'schedule'">
            {{ t('together') }}
          </option>
        </select></label
      >
      <p class="text-xs leading-5 text-n-slate-11">{{ t('groupingHint') }}</p>
    </template>
  </section>
</template>
